<template>
	<div class="card-v2">
		<header class="flex-split mb-8 lg-mb-16">
			<h3 class="m0">Announcements</h3>
			<router-link :to="{}" class="show-xl fs-12" href="">View All Announcements</router-link>
		</header>
		<div class="flex pad-16 border-bottom-07">
			<div class="mr-16 border square-60 no-overflow">
				<img src="//unsplash.it/60/60" alt="" class="block">
			</div>
			<div class="grow">
				<div class="flex-split flex-top">
					<p class="fs-14 fw-700 m0">New Feature!</p>
					<span class="fs-12 pl-16 no-shrink">30 minutes ago</span>
				</div>
				<p class="fs-12 mt-8">Try-hard beard before they sold out, man braid tumeric...</p>
			</div>
		</div>
		<div class="flex pad-16 border-bottom-07">
			<div class="mr-16 border square-60 no-overflow">
				<img src="//unsplash.it/60/60" alt="">
			</div>
			<div class="grow">
				<div class="flex-split flex-top">
					<p class="fs-14 fw-700 m0">ShootWithMe partners with Tave CRM</p>
					<span class="fs-12 pl-16 no-shrink">1 hour</span>
				</div>
				<p class="fs-12 mt-8">This is something that talks about their deal...</p>
			</div>
		</div>
		<div class="flex pad-16">
			<div class="mr-16 border square-60 no-overflow">
				<img src="//unsplash.it/60/60" alt="">
			</div>
			<div class="grow">
				<div class="flex-split flex-top">
					<p class="fs-14 fw-700 m0">Find or Get hired as a Videographer!</p>
					<span class="fs-12 pl-16 no-shrink">1 hour</span>
				</div>
				<p class="fs-12 mt-8">Dreamcatcher roof party kombucha yes plz narwhal...</p>
			</div>
		</div>
		<div class="hide-xl border-top-07 pt-16">
			<router-link :to="{}" class="fs-12">View All Announcements</router-link>
		</div>
	</div>	
</template>

<script>
export default {
	name: 'CardAnnouncements',
	data() {
		return {

		};
	},
}
</script>